"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GgSimpleDatePicker = exports.GgMonthRangePicker = exports.GgMonthPicker = exports.GgDateRangePicker = exports.GgDatePicker = void 0;
var _react = require("react");
var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));
var _DatePicker = _interopRequireWildcard(require("./DatePicker"));
var _DateRangePicker = _interopRequireDefault(require("./DateRangePicker"));
var _useDateControl6 = _interopRequireDefault(require("./useDateControl"));
var _intlTs = require("@gogame/intl-ts");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["timeZone", "template", "presets", "emptyValue", "error", "helper"],
  _excluded2 = ["timeZone", "template", "presets", "error", "helper"],
  _excluded3 = ["timeZone", "template"],
  _excluded4 = ["timeZone", "template"],
  _excluded5 = ["timeZone", "template"]; // TODO: remove styled, update export
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DateTangePickerPropTypes = {
  value: _propTypes["default"].arrayOf(_propTypes["default"].string),
  checkPresetKey: _propTypes["default"].bool,
  checkPresetValue: _propTypes["default"].bool,
  emptyValue: _propTypes["default"].array,
  format: _propTypes["default"].func,
  timeZone: _propTypes["default"].string,
  template: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  label: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  presets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].arrayOf(_propTypes["default"].string),
    value: _propTypes["default"].arrayOf(_propTypes["default"].string),
    label: _propTypes["default"].string
  }))
};
var GgDateRangePicker = exports.GgDateRangePicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var timeZone = _ref.timeZone,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? 'LL' : _ref$template,
    presetsProp = _ref.presets,
    emptyValueProp = _ref.emptyValue,
    error = _ref.error,
    helper = _ref.helper,
    props = _objectWithoutProperties(_ref, _excluded);
  var presets = (0, _intlTs.useDateRangePresets)({
    presets: presetsProp,
    local: true
  });
  var _useDateControl = (0, _useDateControl6["default"])(_objectSpread(_objectSpread({}, props), {}, {
      onChange: props.onChange
    }), {
      timeZone: timeZone,
      template: template
    }),
    format = _useDateControl.format,
    value = _useDateControl.value,
    name = _useDateControl.name,
    onChange = _useDateControl.onChange,
    onFocus = _useDateControl.onFocus,
    onBlur = _useDateControl.onBlur;
  var emptyValue = (0, _react.useMemo)(function () {
    return emptyValueProp && (0, _intlTs.fromUTCToTimeZone)((0, _intlTs.toDate)(emptyValueProp), timeZone);
  }, [emptyValueProp, timeZone]);
  var helperText = error || helper;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl["default"], {
    variant: 'outlined',
    size: 'small',
    fullWidth: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DateRangePicker["default"], _objectSpread(_objectSpread({
      variant: 'outlined',
      size: 'small',
      emptyValue: emptyValue
    }, props), {}, {
      view: 'date',
      presets: presets,
      value: value,
      format: format,
      name: name,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      ref: ref
    })), helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], {
      error: Boolean(error),
      children: helperText
    }) : null]
  });
});
GgDateRangePicker.propTypes = DateTangePickerPropTypes;
var GgMonthRangePicker = exports.GgMonthRangePicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var timeZone = _ref2.timeZone,
    _ref2$template = _ref2.template,
    template = _ref2$template === void 0 ? 'MONTH' : _ref2$template,
    presets = _ref2.presets,
    error = _ref2.error,
    helper = _ref2.helper,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useDateControl2 = (0, _useDateControl6["default"])(props, {
      timeZone: timeZone,
      template: template
    }),
    format = _useDateControl2.format,
    value = _useDateControl2.value,
    name = _useDateControl2.name,
    onChange = _useDateControl2.onChange,
    onFocus = _useDateControl2.onFocus,
    onBlur = _useDateControl2.onBlur;
  var helperText = error || helper;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl["default"], {
    variant: 'outlined',
    size: 'small',
    fullWidth: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DateRangePicker["default"], _objectSpread(_objectSpread({
      variant: 'outlined',
      size: 'small',
      unit: 'month'
    }, props), {}, {
      view: 'month',
      value: value,
      presets: presets,
      format: format,
      name: name,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      ref: ref
    })), helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], {
      error: Boolean(error),
      children: helperText
    }) : null]
  });
});
GgMonthRangePicker.propTypes = DateTangePickerPropTypes;
var GgDatePicker = exports.GgDatePicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var timeZone = _ref3.timeZone,
    _ref3$template = _ref3.template,
    template = _ref3$template === void 0 ? 'LL' : _ref3$template,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var _useDateControl3 = (0, _useDateControl6["default"])(props, {
      timeZone: timeZone,
      template: template
    }),
    format = _useDateControl3.format,
    value = _useDateControl3.value,
    name = _useDateControl3.name,
    onChange = _useDateControl3.onChange,
    onFocus = _useDateControl3.onFocus,
    onBlur = _useDateControl3.onBlur;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker["default"], _objectSpread(_objectSpread({
    variant: 'outlined',
    size: 'small',
    fullWidth: true
  }, props), {}, {
    view: 'date',
    value: value,
    format: format,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: ref
  }));
});
var GgSimpleDatePicker = exports.GgSimpleDatePicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var timeZone = _ref4.timeZone,
    _ref4$template = _ref4.template,
    template = _ref4$template === void 0 ? 'LL' : _ref4$template,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var _useDateControl4 = (0, _useDateControl6["default"])(props, {
      timeZone: timeZone,
      template: template
    }),
    format = _useDateControl4.format,
    value = _useDateControl4.value,
    name = _useDateControl4.name,
    onChange = _useDateControl4.onChange,
    onFocus = _useDateControl4.onFocus,
    onBlur = _useDateControl4.onBlur;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker.SimpleDatePicker, _objectSpread(_objectSpread({
    variant: 'outlined',
    size: 'small',
    fullWidth: true
  }, props), {}, {
    view: 'date',
    value: value,
    format: format,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: ref
  }));
});
var GgMonthPicker = exports.GgMonthPicker = /*#__PURE__*/(0, _react.forwardRef)(function (_ref5, ref) {
  var timeZone = _ref5.timeZone,
    _ref5$template = _ref5.template,
    template = _ref5$template === void 0 ? 'MONTH' : _ref5$template,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var _useDateControl5 = (0, _useDateControl6["default"])(props, {
      timeZone: timeZone,
      template: template
    }),
    format = _useDateControl5.format,
    value = _useDateControl5.value,
    name = _useDateControl5.name,
    onChange = _useDateControl5.onChange,
    onFocus = _useDateControl5.onFocus,
    onBlur = _useDateControl5.onBlur;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker["default"], _objectSpread(_objectSpread({
    variant: 'outlined',
    size: 'small',
    fullWidth: true
  }, props), {}, {
    view: 'month',
    value: value,
    format: format,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: ref
  }));
});
GgMonthPicker.propTypes = {
  label: _propTypes["default"].string.isRequired
};